"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Joystick = void 0;
const react_1 = __importStar(require("react"));
const nipplejs_1 = __importDefault(require("nipplejs"));
const rn_css_1 = require("rn-css");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const Joystick = ({ size = 300, color, style, onStart, onEnd, onMove, onDir, onDirUp, onDirDown, onDirLeft, onDirRight, onPlane, onPlaneUp, onPlaneDown, onPlaneLeft, onPlaneRight, }) => {
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const normalizedSize = normalize(size);
    const zoneJoystickRef = (0, react_1.useRef)(null);
    const [created, setCreated] = (0, react_1.useState)(false);
    const theme = (0, rn_css_1.useTheme)();
    const currentTheme = theme || base_ui_theme_themes_1.defaultTheme;
    const lockX = false;
    const lockY = false;
    const options = {
        color: color || currentTheme.currentPalette.c500,
        mode: "static",
        zone: "zone_joystick",
        size: 0.7 * normalizedSize,
        position: {
            left: "50%",
            top: "50%"
        },
        lockX,
        lockY
    };
    (0, react_1.useEffect)(() => {
        const handleCreateJoystick = () => {
            if (zoneJoystickRef.current !== null) {
                setCreated(() => {
                    console.log(created);
                    if (!created) {
                        createJoystick(zoneJoystickRef.current, options, onStart, onEnd, onMove, onDir, onDirUp, onDirDown, onDirLeft, onDirRight, onPlane, onPlaneUp, onPlaneDown, onPlaneLeft, onPlaneRight);
                    }
                    return true;
                });
            }
        };
        handleCreateJoystick();
        return () => { setCreated(false); };
    }, [
        created,
        onStart, onEnd, onMove,
        onDir, onDirUp, onDirDown, onDirLeft, onDirRight,
        onPlane, onPlaneUp, onPlaneDown, onPlaneLeft, onPlaneRight
    ]);
    return (react_1.default.createElement("div", { ref: zoneJoystickRef, style: Object.assign({ position: 'relative', overflow: "hidden", width: 1 * normalizedSize, height: 1 * normalizedSize }, style) }));
};
exports.Joystick = Joystick;
const createJoystick = (element, options, onStart, onEnd, onMove, onDir, onDirUp, onDirDown, onDirLeft, onDirRight, onPlane, onPlaneUp, onPlaneDown, onPlaneLeft, onPlaneRight) => {
    var joystick = nipplejs_1.default.create({
        zone: element,
        color: options.color,
        lockX: options.lockX,
        lockY: options.lockY,
        mode: options.mode,
        size: options.size,
        position: {
            left: options.position.left,
            top: options.position.top
        }
    });
    joystick.on('start', function (evt, data) {
        onStart(evt, data);
    });
    joystick.on('end', function (evt, data) {
        onEnd(evt, data);
    });
    joystick.on('move', function (evt, data) {
        onMove(evt, data);
    });
    joystick.on('dir', function (evt, data) {
        onDir(evt, data);
    });
    joystick.on('dir:up', function (evt, data) {
        onDirUp(evt, data);
    });
    joystick.on('dir:down', function (evt, data) {
        onDirDown(evt, data);
    });
    joystick.on('dir:left', function (evt, data) {
        onDirLeft(evt, data);
    });
    joystick.on('dir:right', function (evt, data) {
        onDirRight(evt, data);
    });
    joystick.on('plain', function (evt, data) {
        onPlane(evt, data);
    });
    joystick.on('plain:up', function (evt, data) {
        onPlaneUp(evt, data);
    });
    joystick.on('plain:down', function (evt, data) {
        onPlaneDown(evt, data);
    });
    joystick.on('plain:left', function (evt, data) {
        onPlaneLeft(evt, data);
    });
    joystick.on('plain:right', function (evt, data) {
        onPlaneRight(evt, data);
    });
    return joystick;
};
//# sourceMappingURL=joystick.js.map